// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FILE_IS_TOO_BIG = "S\u00fabor je pr\u00edli\u0161 ve\u013ek\u00fd.";
export const WRONG_IMAGE_FORMAT = "Nespr\u00e1vny typ. M\u00e1 ma\u0165 pr\u00edponu JPG.";
